// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1062":"b6ba052b","2443":"0f893d0f"}[chunkId] + ".chunk.css";
};